<script>
    import R, {LOADER} from "../lib/js/requests";
    import app from "../lib/stores/app.js";
    import {copyObject, fnt} from "../lib/js/utils.js";
    import Alert from "../lib/stores/alerts.js";
    import Icon from "../lib/components/icons/Icon.svelte";
    import ReservationSummary from "../book/ReservationSummary.svelte";

    export let reservation;
    export let onNext = fnt();
    export let onBack = fnt();

    let vehicles = [];
    let selected_vehicle = null;
    let initialized = false;

    const initialize = () => {
        // initialize vehicles
        $app.vehicle_types.map(item => {
            vehicles.push(copyObject(item));
        });

        calculate_vehicles();

        load();
    }

    const calculate_vehicles = () => {
        vehicles.map(item => {
            item.quantity = reservation.passengers < item.min_pax ? 0 : Math.ceil(reservation.passengers / item.max_pax);
            item.price = null;
        });
    }

    const set_vehicles_price = prices => {
        vehicles.map(vehicle => {
            let price = prices.find(x => x.vehicle_type_id == vehicle.id);
            vehicle.price = price ? Number(price.price) * vehicle.quantity : null;
        });

        // set selected vehicle
        if (reservation.vehicle != null) {
            selected_vehicle = vehicles.find(x => x.id == reservation.vehicle.id);
            if (selected_vehicle) {
                vehicles = vehicles.filter(x => x.id != selected_vehicle.id);
                vehicles = [selected_vehicle, ...vehicles];
            }
        }
    }

    const select_vehicle = vehicle => {
        selected_vehicle = vehicle;
        submit();
    }

    const load = () => {
        const onSuccess = result => {
            set_vehicles_price(result);
            initialized = true;
        }

        const onFailure = err => {
        };

        if (reservation.routes[0]._pickup?.id == null && reservation.routes[0]._drop?.id == null) {
            initialized = true;
            return;
        }

        let data = {
            location_id: reservation.routes[0]._pickup.id,
            destination_id: reservation.routes[0]._drop.id,
        }

        R.handle(R.transfer.loadPrices, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const submit = () => {
        if (!selected_vehicle) {
            Alert.warning("", "Select a vehicle from the list to continue!");
            return;
        }

        // set selected vehicle and transfer price
        reservation.vehicle = selected_vehicle;
        reservation.start_price = selected_vehicle?.start_price ?? null;
        reservation.price = selected_vehicle.price;

        onNext();
    }

    initialize();
</script>

{#if initialized}
    <div class="row">
        <div class="col-md-5 mb-5">
            <ReservationSummary {reservation} showVehicle={false} showPrice={false}/>
        </div>
        <div class="col-md-7 mb-5">
            <div class="section-title mb-4">
                <h2 class="h4 mb-0">Select vehicle</h2>
            </div>

            <div class="vehicle-select mb-3">
                {#each vehicles as vehicle}
                    <!--{#if vehicle.quantity > 0}-->
                    {#if vehicle.quantity == 1}
                        <button type="button" class="vehicle"
                                class:selected={selected_vehicle && selected_vehicle.id == vehicle.id}
                                on:click={() => select_vehicle(vehicle)}>
                            <span class="body">
                                <span class="heading">
                                    <span class="name">{vehicle.name}</span>
                                    <span class="pax">{vehicle.min_pax} - {vehicle.max_pax} persons</span>
                                </span>
                                <span class="content">
<!--                                    <span class="quantity">x {vehicle.quantity}</span>-->
                                    <span class="price">
                                        <span class="d-block smaller text-gray hidden-xs hidden-sm price-caption">Price</span>
                                        {#if vehicle.price}
                                            <span class="value">€ {vehicle.price.toFixed(2)}</span>
                                        {:else}
                                            On request
                                        {/if}
                                    </span>
                                </span>
                            </span>
                            <span class="info">
                                {vehicle.info}
                            </span>
                        </button>
                    {/if}
                {/each}
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-3 col-md-3 col-6">
            <button type="button"
                    class="btn btn-secondary d-flex align-items-center justify-content-center gap-1 w-100 px-0 py-3"
                    on:click={onBack}>
                <span class="btn-icon"><Icon name="chevron-left" size="16"/></span>
                Back
            </button>
        </div>
        <div class="col-lg-6 col-md-4 hidden-sm hidden-xs"></div>
        <div class="col-lg-3 col-md-5 col-6">
            <button type="button"
                    class="btn btn-primary d-flex align-items-center justify-content-center gap-1 w-100 px-0 py-3"
                    on:click={submit}>
                <span class="hidden-xs hidden-sm">
                    Continue to Personal Info
                </span>
                <span class="hidden-md hidden-lg hidden-xl">
                    Continue
                </span>
                <span class="btn-icon"><Icon name="chevron-right" size="16"/></span>
            </button>
        </div>
    </div>
{/if}

<style>
    .vehicle-select {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: space-evenly;
        gap: 10px;
    }

    .vehicle-select .vehicle {
        color: #000;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.17);
        padding: 20px;
    }

    .vehicle-select .vehicle:hover {
        color: #fff;
        background: #50ba87;
    }

    .vehicle-select .vehicle.selected {
        color: #fff;
        background: #01b3a7;
    }

    .vehicle-select .vehicle:hover .price-caption,
    .vehicle-select .vehicle.selected .price-caption {
        color: #fff !important;
    }

    .vehicle-select .vehicle .body {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .vehicle-select .vehicle .info {
        display: block;
        width: 100%;
        font-size: 14px;
        text-align: left;
        border-top: 1px solid #ececec;
        padding-top: 10px;
        margin-top: 10px;
    }

    .vehicle-select .vehicle .heading {
        display: block;
        flex: 1;
        text-align: left;
    }

    .vehicle-select .vehicle .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
    }

    .vehicle-select .vehicle .name {
        display: block;
        font-weight: 600;
        font-size: 18px;
    }

    .vehicle-select .vehicle .pax {
        display: block;
        font-weight: 300;
    }

    .vehicle-select .vehicle .quantity {
        display: block;
        width: 50px;
        font-size: 1.1rem;
        text-align: center;
    }

    .vehicle-select .vehicle .price {
        display: block;
        width: 100px;
        text-align: right;
    }

    .vehicle-select .vehicle .price .value {
        font-weight: 500;
    }

    @media (max-width: 576px) {
        .vehicle-select .vehicle .body {
            flex-direction: column;
            padding-bottom: 10px;
        }

        .vehicle-select .vehicle .info {
            text-align: center;
            padding-top: 20px;
        }

        .vehicle-select .vehicle .heading {
            width: 100%;
            text-align: center;
        }

        .vehicle-select .vehicle .price {
            display: block;
            width: unset;
            margin-top: 10px;
        }
    }
</style>